import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { AppBar, Box, IconButton, Toolbar, Typography } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { AppBarProps } from '@material-ui/core';
import useLayout from 'src/hooks/useLayout';
import { isDesktop, isMobile } from 'react-device-detect';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
// import ContactsPopover from './ContactsPopover';
// import LanguagePopover from './LanguagePopover';
import Logo from '../Logo';
import NotificationsPopover from './NotificationsPopover';

interface DashboardNavbarProps extends AppBarProps {}

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar: FC<DashboardNavbarProps> = () => {
  const { openMenu, pageTitle } = useLayout();

  return (
    <DashboardNavbarRoot>
      <Toolbar sx={{ minHeight: 64 }}>
        {isMobile && (
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {pageTitle}
          </Typography>
        )}
        {isDesktop && (
          <IconButton
            color="inherit"
            onClick={openMenu}
            sx={{
              display: {
                lg: 'none',
              },
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        )}
        <RouterLink to="/">
          <Logo
            sx={{
              display: {
                lg: 'inline',
                xs: 'none',
              },
              height: 20,
              width: 20,
            }}
          />
        </RouterLink>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        {/* <LanguagePopover /> */}
        {/* <Box sx={{ ml: 1 }}>
                <ContactsPopover />
              </Box> */}
        {isDesktop && (
          <Box sx={{ ml: 1 }}>
            <NotificationsPopover />
          </Box>
        )}
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

export default DashboardNavbar;
